var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TheMenuLayout',[_c('PublicCGV')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }